import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-tooltip',
  templateUrl: './dynamic-tooltip.component.html',
  styleUrls: ['./dynamic-tooltip.component.scss']
})
export class DynamicTooltipComponent implements OnInit {

  @Input() checkTool : string;
  constructor() { }

  ngOnInit(): void {
  }

}
